// src/lang/en_US.js
const en_US = {
  truck: {
    type: "Deliver To",
    type2:"Type",
    cityOrZip: "ZIP Code/City",
    containerSize: "Container",
    PortOfDischarge: "Port Of Discharge",
    getPrice: "Get Now!",
    thirdPart: "3rd Party",
    amazon: "Amazon",
    FBACode: "FBA Code",
    distance: "Straight Distance",
    from: "From",
    to: "To",
    mileage: "Mileage",
    phone: "Phone",
    loading: "Loading",
    total: "Total",
    endTime: "有效期",
    tit: "Contact Information",
    tit2: "Quotation not include",
    tit3: "Explanation",
    tit4: "In case of rejection",
    dan:"Please contact us",
    dan2:"Dilivery distance is too long，Please contact us",
    more:"View More Visit",
    explan: {
      e1: "LIVE UNLOAD Delivery: Waiting time fee of USD 85 per hour, with the first hour free.",
      e2: "Overweight Fee: USD 350 per full container (if the weight of a 20GP exceeds 14.5 tons, this fee will be added; the weight of a 20GP must not exceed 17 tons. If the weight of a 40HQ exceeds 19 tons, this fee will be added; the weight of a 40-HQ must not exceed 21 tons).",
      e3: "Chassis Split Fee: USD150 ( 20' & 45' & LBCT&railway will apply ) Terminal Fee/Inspection Fee/Tax/Layover Fee: At cost",
      e4: "TSCA/PPQFDA Declaration Fee: USD 50/Bill",
      e5: "All plants and wood materials require PPQ declaration.",
      e6: "Products containing composite wood components, wood-based items (excluding pure solid wood), and all products with chemical components require TSCA declaration.",
      e7: "Products with names related to human contact, such as food and pharmaceuticals, need FDA ",
      e8: "1、Overweight Fee: USD 350/40GP&HQ .Weight: Over 19 tons but not exceeding 20.8 tons. If exceeding 20.8 tons, verification is required on a case-by-case basis, and acceptance is not guaranteed. Confirmation is needed for 20GP containers separately.",
      e9: "2、ChassisSplit Fee: $100 (20' & 45' & LBCT& reefer container will apply).",
      e10: "3、ChassisSplit Fee: $100 (20' & 45' & LBCT& reefer container will apply).",
      e11: "Option 1: Return the container to the truck yard and wait for a new appointment for direct delivery. Delivery fee + Yard Storage fee of USD 55 per day.",
      e12: "Option 1: Return the container to the truck yard and wait for a new appointment for direct delivery. Delivery fee + Yard Storage fee of USD 55 per day.",
      e13: "Option 3: Instruct the driver to wait on-site until a new appointment for the same day is available, then check in again. Waiting time fee will be charged.",
    },
    pls: {
      city: "ZIP Code/City",
      FBACode: "FBA Code",
      PortOfDischarge: "Port Of Discharge",
      phone: "Your phone number or Email",
    },
    notic:{
      contact:"Contact information cannot be empty!",
      success:"Success！",
      error:"The email or phone number format is incorrect!",
      null:"Invalid address or Port!",
      null2:"Please contact us",

    },
    table: {
      details: "Details",
      name: "Charge Item",
      amount: "Amount $",
      remark: "Remark",
      clearance: "Customs Clearance Fee",
      terminal: "Terminal Surcharge ",
      chassis: "Chassis Fee",
      delivery: "Delivery charge",
      prePull: "Pre-pull",
      storag: "Storage Fee",
      deliveryAll: "Delivery All-in Fee",
      carrier: "Carrier D/O FEE",
      bill:"/Bill",
      e1:"$50/Day，Min 3Days",
      e2:"Include fuel surcharge",
      e3:"Due to LFD/Warehous/Terminal close",
      e4:"/Day",
      e5:"Request by Carrier/Warehouse",
      expirationDate:"Expiration Date",
    },
    btn: {
      send: "Send",
    }
  },

  desc: {
    notice: 'warning',
    deleteMsg: 'Are you sure you want to delete this data?',
    portOfOri: 'Port of origin initiated',
    portOfDes: 'Port of destination initiated',
    toConfirm: 'To be confirmed',
    feeItem: 'Please select a item',
    feeCharge: 'Please select or enter a charge',
    amount: 'amount cannot be 0 or negative',
    confirmDelete: 'Are you sure to delete',
    delete: 'This operation will permanently delete the record. Do you want to continue?',
    deSuc: 'Success',
    sedSuc: 'Success',
    savSuc: 'Success',
    upSuc: 'Success',
    copySuc: 'Success',
    select: 'Please select a data item first',
    prompt: "Prompt",
    downFile: 'DownLoad File',
    house: 'House Bill No.',
    AHouse: 'Add HBL',
    saveDraft: 'Are you sure you want to save as a draft?',
    sendErr: 'Sending failed, please check the entries!',
    sendErrM: 'Sending failed. Please save the draft and contact customer service!',
    balanceNot: 'Insufficient balance, please recharge!',
    one: 'Leave at least one',
    overTen: 'Your draft box have already over 10 shipments, please clean up asap.',
  },
  title: {
    login: "Login",
    title1: 'Contro center',
    Announcement: 'Announcement',
    sysAnnouncement: 'System Announcement'
  },
  placeholders: {
    forDate: 'select date',
    mbl: 'Please select MBL/HBL',
    name: 'Name',
  },
  rule: {
    name: "Please enter a name",
    address: 'Please enter a address',
    country: 'Please enter a country',
    city: 'Please enter a city',
    cityEr: 'City contains illegal characters',
    nameEr: 'Name contains illegal characters',
    adrEr: 'Address contains illegal characters',
    excel: 'Uploading files can only be in xls or xlsx format',
    max10MB: 'The file size cannot exceed 10MB!',
    upEr: 'Upload failed. Please check if the form is filled out correctly',
    house: 'The House has no content filled in!',
    errorRule: 'Contains illegal characters (note illegal and invisible characters)',
    upAndNotSpc: 'Uppercase characters and numbers, no spaces allowed',
    max3mi: 'Up to 3 decimal places',
    max5: 'Up to 5 characters',
    max10: 'Up to 10 characters',
    max12: 'Up to 12 characters',
    max14: 'Up to 14 characters',
    max15: 'Up to 15 characters',
    j6: 'Can only be 6 digits',
    Mnu: 'Please enter a positive integer.',
    shipCompany: 'Please enter a Carrier Name',
    mbl: 'Please enter a Master Bill No.',
    mblDuplicated: "duplicated SCAC CODE",
    vesse: 'Please enter a vessel',
    voyage: 'Please enter a voyage',
    place: 'Please enter a Place Receipt',
    loadingPort: 'Please enter a loading Port',
    dischargePort: 'Please enter a Unlading Port',
    SCACCODE: '',
    etd: 'Please enter a etd',
    eta: 'Please enter a eta',
    hbl: 'Please enter a House Bill No.',
    containerNo: 'Please enter a containerNo.',
    containerSign: 'Fill in NC for non container',
    sealNo: 'Please enter a sealNo.',
    containerType: 'Please enter acontainer type',
    description: 'Please enter a description',
    marks: 'Please enter a Marks',
    packageCartons: 'Please enter a Pieces',
    packageType: 'Please enter a package type',
    grossWeight: 'Please enter a gross weight',
    CBM: 'Please enter a CBM',
    noSeal: 'If no seal number,  fill in uppercase NOSEAL',
    shpper: 'Tip: Please be sure to fill in the real shpper information, otherwise, being returned by the destination port, resulting in fines and other consequences borne by the user.',
    consignee: 'Tip: Please be sure to fill in the real consignee information, otherwise, being returned by the destination port, resulting in fines and other consequences borne by the user.',
    notify: 'Tip: Please be sure to fill in the real notify information, otherwise, being returned by the destination port, resulting in fines and other consequences borne by the user.',
    underNow: 'Must be later than today',
    aUnderd: 'The ETA must be later than the ETD',
    min1: 'Please keep at least one House order'
  },
  btn: {
    Funds: 'Funds',
    sendAg: 'Submit',
    deleteBill: 'Delete',
    amsExport: 'Export AMS',
    saveAMs: 'Save Draft',
    submitAms: 'Submit',
    modify: "Modify",
    view: "View",
    history: 'History',
    copy: 'Copy',
    delete: "Delete",
    deleteList: "Delete Selected",
    more: "More",
    reset: "Reset",
    confirm: 'Confirm',
    cancel: 'Cancel',
    exportExcel: 'Export To Excel',
    search: 'Search',
    Voided: 'Voided',
    add: 'Add',
    hide: 'Quick Search',
    open: 'Open Search',
    hide: 'Hide',
    hideTopic: 'Hide',
    hideBtn: 'Hide',
    openTopic: 'open',
    null: 'No Data',
    downTep: 'Template Download',
    operate: 'Operate',
    isf: 'ISF Message',
    ams: 'AMS Export'
  },
  label: {
    email: "Email",
    password: "Password",
  },
  leftBar: {
    title: 'US AN SYSTEM',
    controller: 'ConTrol Center',
    send: 'Shipment List',
    confirm: 'To be confirmed',
    fee: 'Collect Charge'
  },
  control: {
    tit1: 'Status',
    tit2: 'Notice',
    press: 'In Process',
    msg1: {
      msg1: 'Arrive in 5 days',
      msg2: 'AN not sent',
      msg3: 'Original B/L'
    },
    msg2: {
      msg1: 'Conssignee',
      msg2: 'AN no response'
    },
    msg3: {
      msg1: 'Overdue',
      msg2: 'No pick up'
    },
    msg4: {
      msg1: 'Overdue',
      msg2: 'No return'
    },
    msg5: "",
    msg6: "To be confirmed",
  },
  fee: {
    title: 'Edit Collect',
    columns: {
      column1: 'Name',
      column2: 'Date',
      column3: 'Item',
      column4: 'AN Sent Date',
      column5: 'ATA',
      column6: 'Charge',
      column7: 'Amount',
      column8: 'Receipt Date',
      column9: 'operate'
    }
  },
  confirm: {
    columns: {
      column1: 'Name',
      column2: 'Date',
      column3: 'Item',
      column4: 'To be confirmed/confirm',
      column5: 'operate'
    }
  },
};
export default en_US;
